import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const MetaContext = createContext(null);
export const useMeta = () => useContext(MetaContext);

const MASTER_TYPES = [
  "sales_category", "sales_channel", "expense_category", "inventory_category",
  "unit", "payment_method", "department", "wastage_reason", "adjustment_reason", "supplier_category",
];

export function MetaProvider({ children }) {
  const { user } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [masters, setMasters] = useState({});

  const load = useCallback(async () => {
    const results = await Promise.allSettled([
      api.get("/outlets"),
      ...MASTER_TYPES.map((t) => api.get("/settings/masters", { params: { type: t } })),
    ]);
    const [o, ...ms] = results;
    setOutlets(o.status === "fulfilled" ? (o.value.data || []) : []);
    const map = {};
    MASTER_TYPES.forEach((t, i) => {
      map[t] = ms[i]?.status === "fulfilled" ? (ms[i].value.data || []) : [];
    });
    setMasters(map);
  }, []);

  useEffect(() => { if (user && user.id) load(); }, [user, load]);

  const options = (type) => (masters[type] || []).filter((m) => m.active !== false).map((m) => ({ value: m.name, label: m.name }));
  const outletOptions = outlets.map((o) => ({ value: o.id, label: o.name }));
  const outletName = (id) => outlets.find((o) => o.id === id)?.name || (id ? "—" : "All outlets");

  return (
    <MetaContext.Provider value={{ outlets, outletOptions, outletName, options, masters, reloadMeta: load }}>
      {children}
    </MetaContext.Provider>
  );
}
